module.exports = __webpack_public_path__ + "static/media/arrows-v.6262dd83.svg";